export default __webpack_public_path__ + "static/media/process.255fbe48.png";